<template>
  <button
    :style="getStyle"
    class="button"
    @click="$emit('click')"
    :class="getTypes"
    :disabled="disabled">
    <span v-if="!icon">{{ label }}</span>
    <slot/>
  </button>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'ChatButton',
  props: {
    label: {
      type: String
    },
    types: {
      type: Array,
      default: () => []
    },
    size: {
      type: Number
    },
    disabled: {
      type: Boolean
    },
    icon: {
      type: Boolean,
      default: false
    }
  },
  setup (props) {
    const getTypes = computed(() => {

      return {
        'round': props.types.includes('round'),
        'secondary': props.types.includes('secondary'),
        'primary': props.types.includes('primary'),
        'endflow': props.types.includes('endflow'),
        'transparent': props.types.includes('transparent'),
        'disabled': props.disabled,
        'icon': props.icon
      }
    })

    return{
      getTypes
    }
  },
  computed: {
    getStyle () {
      if (!this.size) {
        return
      }

      return {
        'height': `${this.size}px`,
        'width': `${this.size}px`,
        'min-width': `${this.size}px`
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.button {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;
  padding: 8px 24px;
  margin: 5px 0;
  border-radius: 30px;
  font-weight: bold;
  min-width: 80px;
  outline: none;
  cursor: pointer;
  text-transform: none;
  border: none;
  span {
    font-size: 15px;
  }
  &.transparent {
    background-color: transparent;
    color:var(--tw-c-original-green);
    border: 1px solid var(--tw-c-original-green);
    &:active {
      background-color: rgba(91, 172, 38, 0.2);
    }
  }
  &.round {
    height: 35px;
    width: 35px;
    min-width: 35px;
    padding: 0;
    border-radius: 50%;
    background: none;
  }
  &.primary {
    background-color: var(--tw-c-original-green);
    color: white;
    fill: white;
    &:hover {
      background-color: #6eb640;
    }
  }
  &.secondary {
    background-color: white;
    color:var(--tw-c-original-green);
    border: 1px solid var(--tw-c-original-green);
    &:hover {
      background-color: #ecf5e5;
    }
  }
  &.disabled, &.disabled:hover {
    color: #dddddd;
    cursor: default;
    fill: white;
    background-color: rgba(0,0,0,0.12);
    border-color: rgba(0,0,0,0.12);
  }
  &.icon {
    width: 24px;
    height: 24px;
    padding: 0px;
    background-color: white;
    cursor: pointer;
    border: none;
  }
  &.endflow {
    border: none;
  }
}
</style>
